import { useEffect, useState } from "react";
import { FaHeart } from "react-icons/fa"; // Import Heart icon
import { getUser } from "../Utility/getUser"; // Import the getUser function
import Footer from "../Footer/Footer"; // Import Footer component

const MyFavorite = () => {
  const [favorites, setFavorites] = useState([]);
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchFavorites = async () => {
      const user = getUser();
      if (user) {
        try {
          const response = await fetch(`https://panel.masit.net/api/view.php?table=myfavorite&favorite_usersid=${user.users_id}`);
          const data = await response.json();
          if (Array.isArray(data)) {
            setFavorites(data);
            const carIds = data.map(fav => fav.favorite_itemsid);
            fetchCars(carIds);
          }
        } catch (error) {
          console.error("Error fetching favorite data:", error);
        }
      }
    };

    const fetchCars = async (carIds) => {
      try {
        const response = await fetch("https://panel.masit.net/api/view.php?table=items"); // Replace with your API endpoint
        const data = await response.json();
        const favoriteCars = data.filter(car => carIds.includes(car.items_id));
        setCars(favoriteCars);
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };

    fetchFavorites();
  }, []);

  const handleRemoveFavorite = async (carId) => {
    const user = getUser();
    if (!user) {
      alert('Please log in to remove favorites');
      return;
    }

    try {
      const response = await fetch('https://panel.masit.net/api/product/deleteFromTable.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          table: 'favorite',
          where: 'favorite_itemsid = ? and favorite_usersid = ?',
          values: [carId, user.users_id],
        }),
      });

      const data = await response.json();
      console.log('Remove response:', data); // Log the response for debugging
      if (data.status?.includes("success")) {
        setFavorites(favorites.filter(fav => fav.favorite_itemsid !== carId));
        setCars(cars.filter(car => car.items_id !== carId));
      } else {
        console.error('Failed to remove from favorites:', data.message);
      }
    } catch (error) {
      console.error('Error removing from favorites:', error);
    }
  };

  return (
    <div className="pb-24">
      <div className="container">
        {/* Heading */}
        <h1
          data-aos="fade-up"
          className="text-3xl sm:text-4xl font-semibold font-serif mb-3 text-gray-900 dark:text-white"
        >
          My Favorite Cars
        </h1>
        <p data-aos="fade-up" data-aos-delay="400" className="text-sm pb-10 text-gray-700 dark:text-gray-300">
          Here are the cars you have added to your favorites.
        </p>
        {/* Favorite car listing */}
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-16">
            {cars.map((car, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={car.aosDelay}
                className="space-y-3 border-2 border-gray-300 hover:border-red-600 dark:border-gray-700 dark:hover:border-red-600 p-3 rounded-xl relative group"
              >
                <a href={`/ProductDetail/${car.items_id}`} className="block w-full h-[120px] relative">
                  <img
                    src={car.items_image}
                    alt={car.items_name}
                    className="w-full h-[120px] object-contain sm:translate-x-8 group-hover:sm:translate-x-16 duration-700"
                  />
                </a>
                <div className="space-y-2">
                  <h1 className="text-red-500 font-semibold">{car.items_name}</h1>
                  <div className="flex justify-between items-center text-xl font-semibold">
                    <p>€{car.items_price}/Day</p>
                    <a href={`/ProductDetail/${car.items_id}`}>{car.items_desc}</a>
                  </div>
                </div>
                <p className="text-l font-semibold absolute top-0 left-3">
                  {car.aosDelay} KM
                </p>
                <button
                  onClick={() => handleRemoveFavorite(car.items_id)}
                  className="absolute top-3 right-3 text-red-500"
                >
                  <FaHeart />
                </button>
              </div>
            ))}
          </div>
        </div>
        {/* End of favorite car listing */}
      </div>
      <Footer />
    </div>
  );
};

export default MyFavorite;